import React from 'react';

import MuiDialogActions from '@mui/material/DialogActions';
import Dialog from 'components/Dialog';
import {Theme} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from 'components/Button';
import i18n from 'i18n';

const DialogActions = withStyles((theme: Theme) => ({
   root: {
      margin: 0,
      padding: theme.spacing(1),
   },
}))(MuiDialogActions);

type Props = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   confirmLabel?: string;
   cancelLabel?: string;
   onOk?: () => void;
   onCancel?: () => void;
};
export const ConfirmationDialog = (props: Props) => {
   const {
      open = true,
      content = i18n.t('Proceed?'),
      title = i18n.t('Confirmation'),
      confirmLabel = i18n.t('Ok'),
      cancelLabel = i18n.t('Cancel'),
      onOk,
      onCancel,
   } = props;

   return (
      <Dialog header={title} open={open}>
         {content}
         <DialogActions>
            <Button onClick={onOk} color="primary">
               {confirmLabel}
            </Button>
            <Button autoFocus onClick={onCancel} color="primary">
               {cancelLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
};
